(() => {
  function mount() {
    const noticeTemplate = document.querySelector('[data-tp-not-included-template]');
    const slots = [...document.querySelectorAll('[data-tp-notice-slot]')];
    if (noticeTemplate && slots.length) {
      const notice = document.querySelector('[data-tp-not-included]') || noticeTemplate.content.firstElementChild.cloneNode(true);
      const normalize = text => text.toLowerCase().replace(/[^a-z0-9]+/g, '');
      const noticeText = normalize(noticeTemplate.content.querySelector('p').textContent);
      const title = slot => slot.closest('[data-feature-title]').dataset.featureTitle;
      const matchingCopy = slots.find(slot => normalize(slot.parentElement.querySelector(':scope > p').textContent).includes(noticeText));
      const manualRelease = noticeText.includes('pushbutton') && slots.find(slot => title(slot) === 'Helps collect loose fur');
      const manualPower = noticeText.includes('batteries') && slots.find(slot => /batteries|charging/i.test(title(slot)));
      const packageContents = slots.find(slot => title(slot) === 'Package contents');
      const slot = manualRelease || matchingCopy || manualPower || packageContents || slots.at(-1);
      notice.querySelector('p').textContent = noticeTemplate.content.querySelector('p').textContent;
      if (!slot.contains(notice)) slot.append(notice);
    }
    document.querySelectorAll('[data-tp-product]').forEach(root => {
      if (root.dataset.tpReady) return;
      root.dataset.tpReady = 'true';
      const variants = JSON.parse(root.querySelector('[data-tp-variants]').textContent);
      const form = root.querySelector('form');
      const purchase = root.querySelector('[data-tp-purchase]');
      const gallery = root.querySelector('[data-tp-gallery]');
      const frames = [...root.querySelectorAll('[data-media-id]')];
      const thumbs = [...root.querySelectorAll('[data-tp-thumb]')];
      const sticky = root.querySelector('[data-tp-sticky]');
      const quantity = form.elements.quantity;
      const smallScreen = matchMedia('(max-width:749px)');
      let current = variants.find(variant => String(variant.id) === form.elements.id.value) || variants[0];
      let submitting = false;
      function chooseMedia(id, scroll = true) {
        const target = frames.find(frame => frame.dataset.mediaId === String(id)) || frames[0];
        frames.forEach(frame => {
          frame.classList.toggle('is-current', frame === target);
          if (frame !== target) frame.querySelectorAll('video').forEach(video => video.pause());
        });
        thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tpThumb === target?.dataset.mediaId)));
        if (smallScreen.matches && scroll && target) gallery.scrollTo({left: target.offsetLeft - frames[0].offsetLeft, behavior: 'instant'});
      }
      function updateVariant() {
        const values = [...form.querySelectorAll('[data-option-position]')].map(fieldset => fieldset.querySelector('input:checked')?.value);
        const variant = values.length ? variants.find(variant => variant.options.every((value,index) => value === values[index])) : variants[0];
        if (!variant) return;
        current = variant;
        form.elements.id.value = variant.id;
        root.querySelectorAll('[data-tp-price]').forEach(element => element.textContent = variant.price);
        root.querySelector('[data-tp-sku]').textContent = variant.sku || '';
        root.querySelector('[data-tp-sku-row]').hidden = !variant.sku;
        const contents = root.querySelector('[data-tp-contents]');
        if (contents) {contents.hidden = !variant.contents;contents.querySelector('span').textContent = variant.contents || '';}
        root.querySelector('[data-tp-sticky-size]').textContent = variant.title;
        const image = root.querySelector('.tp-sticky-image');
        if (image && variant.image) {image.removeAttribute('srcset');image.src = variant.image;}
        quantity.min = variant.quantityRule.min || 1;
        quantity.step = variant.quantityRule.increment || 1;
        if (variant.quantityRule.max) quantity.max = variant.quantityRule.max; else quantity.removeAttribute('max');
        if (!quantity.checkValidity()) quantity.value = quantity.min;
        root.querySelectorAll('[data-tp-add],[data-tp-sticky-add]').forEach(button => {button.disabled = !variant.available; button.textContent = variant.available ? 'Add to cart' : 'Sold out';});
        chooseMedia(variant.mediaId);
        const url = new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(null,'',url);
      }
      form.querySelectorAll('.tp-options input').forEach(input => input.addEventListener('change',updateVariant));
      thumbs.forEach(button => button.addEventListener('click',() => chooseMedia(button.dataset.tpThumb)));
      root.querySelectorAll('[data-tp-quantity-step]').forEach(button => button.addEventListener('click',() => {
        const value = Number(quantity.value) + Number(button.dataset.tpQuantityStep) * Number(quantity.step || 1);
        quantity.value = Math.max(Number(quantity.min || 1),Math.min(Number(quantity.max || Infinity),value));
      }));
      function updateSticky() {
        sticky.hidden = !smallScreen.matches || purchase.getBoundingClientRect().bottom >= 0;
        const previewBar = document.getElementById('PBarNextFrameWrapper');
        const previewBounds = previewBar?.getBoundingClientRect();
        const previewVisible = previewBounds && previewBounds.height > 0 && previewBounds.bottom <= innerHeight + 1 && previewBounds.top >= 0;
        sticky.style.bottom = `${previewVisible ? previewBounds.height : 0}px`;
      }
      let stickyFrame;
      function scheduleSticky() {
        if (stickyFrame) return;
        stickyFrame = requestAnimationFrame(() => {stickyFrame = null;updateSticky();});
      }
      window.addEventListener('scroll',scheduleSticky,{passive:true});
      window.addEventListener('resize',scheduleSticky);
      new MutationObserver(scheduleSticky).observe(document.body,{childList:true});
      const purchaseObserver = new IntersectionObserver(updateSticky,{threshold:0});purchaseObserver.observe(purchase);
      smallScreen.addEventListener('change',() => {chooseMedia(current.mediaId);updateSticky();});
      const frameObserver = new IntersectionObserver(entries => {
        if (!smallScreen.matches) return;
        const active = entries.find(entry => entry.isIntersecting && entry.intersectionRatio >= .6);
        if (active) chooseMedia(active.target.dataset.mediaId,false);
      },{root:gallery,threshold:.6});frames.forEach(frame => frameObserver.observe(frame));
      root.querySelector('[data-tp-sticky-add]').addEventListener('click',() => form.requestSubmit());
      form.addEventListener('submit',async event => {
        event.preventDefault();if (submitting || !current.available || !form.reportValidity()) return;
        submitting = true;
        const status = root.querySelector('[data-tp-cart-status]');status.hidden = false;status.textContent = 'Adding to cart...';
        root.querySelectorAll('[data-tp-add],[data-tp-sticky-add]').forEach(button => button.setAttribute('aria-busy','true'));
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
          const result = await response.json();if (!response.ok) throw Error(result.description || result.message || 'Unable to add to cart.');
          status.textContent = 'Added to cart.';root.querySelector('[data-tp-cart-link]').hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh',{detail:result}));
        } catch (error) {status.textContent = error.message;}
        finally {submitting = false;root.querySelectorAll('[data-tp-add],[data-tp-sticky-add]').forEach(button => button.removeAttribute('aria-busy'));}
      });
      chooseMedia(current.mediaId);updateSticky();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mount); else mount();
  document.addEventListener('shopify:section:load',mount);
})();
